import { getTokenCache } from '../getTokenCache';
import type { TokenRequestParams } from '../schema/TokenRequestParams';

export function getCachedTokenIfAvailable(tokenRequestParams: TokenRequestParams) {
    const tokenCache = getTokenCache();
    const cacheKey = tokenCache.getCacheKey(tokenRequestParams);
    return tokenCache.getCachedToken(cacheKey);
}
